<template>
  <p>
    The VIZBI 2010 posters are available at
    <a href="http://vizbi.org/Posters/2010/">vizbi.org/Posters/2010</a>.
  </p>
</template>
